<div *ngIf="promoBanner" class="contents">
  <div class="logo-wrapper">
    <app-icon *ngIf="icon; else imageLogo" [icon]="icon" class="logo">
    </app-icon>

    <img
      #imageLogo
      *ngIf="promoBanner.logoSrc as logoSrc"
      [src]="logoSrc"
      class="logo"
    />
  </div>

  <div class="body">
    <div class="message">
      <h4 *ngIf="promoBanner.title as title" class="title">
        {{ title }}
      </h4>

      <p class="description">
        {{ promoBanner.description }}
      </p>
    </div>

    <div class="cta-wrapper">
      <i2g-router-link
        *ngIf="cta1"
        buttonStyle="tertiary"
        class="cta-action"
        [label]="cta1.label"
        [route]="cta1.route"
        [navigationExtras]="cta1.navigationExtras"
        [trackingObject]="promoBanner.trackingObject"
        [trackingAction]="cta1Action"
        [trackingAdditionalProperties]="cta1.trackingAdditionalProperties"
        (linkClick)="onCta1.emit()"
      >
      </i2g-router-link>

      <i2g-router-link
        *ngIf="cta2"
        buttonStyle="tertiary"
        class="cta-action cta2"
        [label]="cta2.label"
        [route]="cta2.route"
        [navigationExtras]="cta2.navigationExtras"
        [trackingObject]="promoBanner.trackingObject"
        [trackingAction]="cta2Action"
        [trackingAdditionalProperties]="cta2.trackingAdditionalProperties"
        (linkClick)="onCta2.emit()"
      >
      </i2g-router-link>
    </div>
  </div>

  <div class="close-wrapper">
    <button
      *ngIf="!promoBanner.hideClose"
      class="close"
      trackable
      [trackingObject]="promoBanner.trackingObject"
      [trackingAction]="dismissAction"
      (click)="onDismiss.emit()"
    >
      <app-icon [icon]="closeIcon"></app-icon>
    </button>
  </div>
</div>
